import * as Telecom from '@servicetitan/telecom-rtcs-client';
import isEqual from 'lodash/isEqual';
import getQueue from '../../lib/getQueue';
import refreshQueues from '../../lib/refreshQueues';
import log from '../../lib/log';

async function handleQueueStatus(event: Telecom.QueueStatusEvent) {
  const queue = getQueue(event.queueId);

  if (!queue) {
    await refreshQueues();
    return;
  }

  let isChanged = false;

  if (queue.status.abandonedSessions !== event.stats.abandonedSessions) {
    queue.status.abandonedSessions = event.stats.abandonedSessions;
    isChanged = true;
  }
  if (queue.status.activeSessionCount !== event.stats.activeSessions) {
    queue.status.activeSessionCount = event.stats.activeSessions;
    isChanged = true;
  }
  if (queue.status.averageWait !== event.stats.averageWaitMs) {
    queue.status.averageWait = event.stats.averageWaitMs;
    isChanged = true;
  }
  if (queue.status.longestWait !== event.stats.longestWaitMs) {
    queue.status.longestWait = event.stats.longestWaitMs;
    isChanged = true;
  }
  if (queue.status.missedSessions !== event.stats.missedSessions) {
    queue.status.missedSessions = event.stats.missedSessions;
    isChanged = true;
  }
  if (queue.status.recipientCount !== event.stats.agents) {
    queue.status.recipientCount = event.stats.agents;
    isChanged = true;
  }
  if (queue.status.totalSessions !== event.stats.totalSessions) {
    queue.status.totalSessions = event.stats.totalSessions;
    isChanged = true;
  }
  if (queue.status.activeRecipientCount !== event.activeAgents) {
    queue.status.activeRecipientCount = event.activeAgents;
    isChanged = true;
  }
  if (queue.status.availableRecipientCount !== event.availableAgents) {
    queue.status.availableRecipientCount = event.availableAgents;
    isChanged = true;
  }

  if (queue.status.estimatedWait !== event.stats.estimatedWaitMs) {
    queue.status.estimatedWait = event.stats.estimatedWaitMs;
    isChanged = true;
  }

  if (!isEqual(queue.memberIds, event.agentIds)) {
    queue.memberIds = event.agentIds;
    isChanged = true;
  }
  if (!isEqual(queue.name, event.queueName)) {
    queue.name = event.queueName;
    isChanged = true;
  }

  if (isChanged) {
    log('rtcs:queue:status:' + queue?.name, event);
  }
}

export default handleQueueStatus;
